import i18n from '@/i18n'
import { isObjEmpty, isStrEmpty } from '@/utils/utils'
import langFr from '@/locales/fr.json';

export default {
    data(): any {
        return {}
    },

    methods: {
        getTranslatedText(text: string, xargs: any = {}) {
            const langDefault: any = langFr

            if (!text) {
                return
            }
            const rsText = text.toLowerCase()
            let translatedText: any = text;
            
            if (!isStrEmpty(langDefault[rsText])) {
                translatedText = i18n.t(rsText.toString());
            }

            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    translatedText = translatedText.replace('[' + key + ']', xargs[key])
                }
            }
            let capitalizedSentence = translatedText.charAt(0).toUpperCase() + translatedText.slice(1)
            return capitalizedSentence
        },
    },
}
